/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type AppItemRecommendationsVariables = Types.Exact<{
  uuid: Types.Scalars['String']
  count: Types.Scalars['Int']
}>

export type AppItemRecommendations = {
  __typename: 'Query'
  currentCart: {
    __typename: 'Cart'
    id: number | null
    uuid: string | null
    items: Array<{ __typename: 'CartItem'; quantity: number }>
    location: {
      __typename: 'Location'
      id: number
      allowOrders: boolean
      workStatus: Types.LocationWorkStatus
      truck: { __typename: 'Truck'; id: number; name: string }
    } | null
    itemRecommendations: Array<{
      __typename: 'LocationItem'
      id: number
      status: Types.LocationItemStatus
      item: {
        __typename: 'Item'
        id: number
        name: string
        active: boolean
        tags: Array<{
          __typename: 'ItemTag'
          id: string
          name: string
          image200Url: string | null
          highlighted: boolean
        }>
        image: { __typename: 'ItemImage'; medium: string }
        price: { __typename: 'Money'; formatted: string }
      }
    }>
  } | null
}

export const AppItemRecommendationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'appItemRecommendations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'count' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentCart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'uuid' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'quantity' }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'location' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allowOrders' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'workStatus' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'truck' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'itemRecommendations' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'count' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'count' }
                      }
                    }
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'item' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'tags' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image200Url' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'highlighted' }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'active' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'medium' }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'price' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'formatted' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode

/**
 * __useAppItemRecommendations__
 *
 * To run a query within a React component, call `useAppItemRecommendations` and pass it any options that fit your needs.
 * When your component renders, `useAppItemRecommendations` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppItemRecommendations({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useAppItemRecommendations(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    AppItemRecommendations,
    AppItemRecommendationsVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    AppItemRecommendations,
    AppItemRecommendationsVariables
  >(AppItemRecommendationsDocument, options)
}
export function useAppItemRecommendationsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AppItemRecommendations,
    AppItemRecommendationsVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    AppItemRecommendations,
    AppItemRecommendationsVariables
  >(AppItemRecommendationsDocument, options)
}
export type AppItemRecommendationsHookResult = ReturnType<
  typeof useAppItemRecommendations
>
export type AppItemRecommendationsLazyQueryHookResult = ReturnType<
  typeof useAppItemRecommendationsLazyQuery
>
export type AppItemRecommendationsQueryResult = Apollo.QueryResult<
  AppItemRecommendations,
  AppItemRecommendationsVariables
>
